import React, { forwardRef, useEffect, useState } from 'react';
import styles from './itinerarySection.module.css';
import CharCount from '../../charCount/CharCount';
import ReactQuill from 'react-quill';
import { modules } from '../../../utils/quillModules';
import { formats } from '../../../utils/quillFormats';
import useSectionHighlightRef from '../../../hooks/useSectionHighlightRef';

const ItinerarySection = forwardRef(
    ({ title = 'Activity', itemLabel = 'Activity', minItems = 1, data, setData, isEdit }, ref) => {
        const [count, setCount] = useState(data?.itinerary?.length);
        const { sectionRef, highlightField } = useSectionHighlightRef(ref);

        useEffect(() => {
            setCount(data?.itinerary?.length);
            //eslint-disable-next-line
        }, [isEdit, data?.itinerary]);

        const handleItinaryChange = (event, index, type) => {
            setData((prev) => {
                const updatedArray = prev.itinerary.map((item, itemKey) => {
                    if (index === itemKey) {
                        if (type === 'dayHeading') return { ...item, [event.target.name]: event.target.value };
                        else return { ...item, dayDescription: event };
                    }
                    return item;
                });
                return {
                    ...prev,
                    itinerary: updatedArray
                };
            });
        };

        function addItem() {
            setData((prevState) => {
                return {
                    ...prevState,
                    itinerary: [...prevState.itinerary, { dayHeading: '', dayDescription: '' }]
                };
            });
            setCount(count + 1);
        }

        const deleteItem = () => {
            if (count > 1) {
                setData((prevState) => {
                    const updatedArray = [...prevState.itinerary];
                    updatedArray.pop();
                    return {
                        ...prevState,
                        itinerary: updatedArray
                    };
                });
                setCount(count - 1);
            }
        };

        return (
            <div ref={sectionRef}>
                <h2 className={styles.orgPackUpH2}>{title}</h2>

                <div className={styles.orgPackUpSecDiv}>
                    {data?.itinerary?.map((item, index) => (
                        <div key={index}>
                            <p className={styles.activityLabel}>
                                {itemLabel} {index + 1}
                            </p>

                            {/* Heading */}
                            <div className={styles.activityInDiv}>
                                <label className={styles.activityLabel}>Heading</label>

                                <div className={styles.activityInputDiv}>
                                    <input
                                        type='text'
                                        name='dayHeading'
                                        placeholder={`${itemLabel} ${index + 1} Heading`}
                                        className={`${styles.activityInput} ${highlightField === 'dayHeading' ? 'error-highlight' : ''}`}
                                        value={item?.dayHeading || ''}
                                        onChange={(event) => handleItinaryChange(event, index, 'dayHeading')}
                                        disabled={isEdit && data.status !== 'inactive' && data.status !== 'rejected'}
                                    />
                                    <CharCount
                                        string={data?.itinerary[index] ? data?.itinerary[index]?.dayHeading : ''}
                                        min={3}
                                        limit={60}
                                    />
                                </div>
                            </div>

                            {/* Description */}
                            <div className={styles.activityDiv}>
                                <label className={styles.activityLabel}>Description</label>

                                <div className={styles.activityDescDiv}>
                                    <ReactQuill
                                        name='dayDescription'
                                        theme='snow'
                                        placeholder={`${itemLabel} ${index + 1} Description`}
                                        value={item?.dayDescription || ''}
                                        onChange={(value) => handleItinaryChange(value, index, 'dayDescription')}
                                        modules={modules}
                                        formats={formats}
                                        readOnly={isEdit && data.status !== 'inactive' && data.status !== 'rejected'}
                                    />

                                    <CharCount
                                        string={data?.itinerary[index] ? data?.itinerary[index]?.dayDescription : ''}
                                        min={20}
                                        limit={1500}
                                    />
                                </div>
                            </div>
                        </div>
                    ))}

                    {/* Buttons */}
                    <div className={`alignButtons ${styles.activityBtn}`}>
                        <button type='button' onClick={addItem} className={styles.activityAddBtn}>
                            Add {itemLabel}
                        </button>

                        <button
                            type='button'
                            onClick={deleteItem}
                            className={styles.activityDelBtn}
                            disabled={count === minItems}
                        >
                            Delete {itemLabel}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
);

export default ItinerarySection;
